
import React from 'react';
import { ArrowRight } from 'lucide-react';

const InterlinkBanner = () => {
  return (
    <div className="bg-[#1A1A1A] text-white py-12 px-4 border-t border-[#00A3B1]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
        <div>
          <h3 className="text-2xl font-bold mb-2">Envie de découvrir le lagon en bateau privé ?</h3>
          <p className="text-gray-400">Laissez Greg et Anaïs vous guider vers les spots secrets du lagon.</p>
        </div>
        <a 
          href="https://tahaa-excursions.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#00A3B1] hover:bg-[#008C99] text-white px-8 py-4 rounded-full font-bold transition-all hover:scale-105 shadow-lg shadow-[#00A3B1]/20"
        >
          Visitez Tahaa Lagoon Explorer
          <ArrowRight className="h-5 w-5" />
        </a>
      </div>
    </div>
  );
};

export default InterlinkBanner;
